exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._7ahQImyV4dj0EpcNOjnwA{\n    background: #d3d3d3;\n    color: #5A5A5A;\n}\n\n.lhyQmCtWOINviMz0WG_gr{\n    background: #bebebe;\n    color: #5A5A5A;\n}\n\n._3vt7_Mh4hRCFbp__dFqBCI li:hover{\n    background: #bebebe;\n    color: #5A5A5A;\n}\n\n#multiselectContainerReact{\n    width: 100%;\n}\n\n._2iA8p44d0WZ-WqRBGcAuEV{\n    border: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/my-jeeva/projectmgmt/Physician.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/my-jeeva/projectmgmt/Physician.css
// module chunks = 0